import { BankLinkStatus, PartnerType, UserQuery, UserQueryVariables } from "@ctypes";
import { USER } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useUser = () => {
  const { data: queryData, ...rest } = useQuery<UserQuery, UserQueryVariables>(USER);

  const user = queryData?.user;
  const beneficiaries = queryData?.beneficiaries;
  const bankLinks = queryData?.getBankLinks;
  const bankAccounts = queryData?.getBankAccounts;

  const disconnectedAccounts =
    bankLinks?.filter((bankLink) => bankLink?.status === BankLinkStatus.Disconnected) ?? [];

  const settings = user?.settings;
  const hasReferralAccess = Boolean(settings?.referralsEnabled);
  const userId = user?.id;

  const hasBankAccount = Boolean(bankAccounts && bankAccounts.length > 0);

  const isIntegratedPartner = Boolean(
    (user?.partnerType === PartnerType.IntegrationDirect ||
      user?.partnerType === PartnerType.IntegrationWhitelabel) &&
    user?.partner,
  );

  return {
    user,
    beneficiaries,
    bankLinks,
    bankAccounts,
    disconnectedAccounts,
    settings,
    hasReferralAccess,
    userId,
    hasBankAccount,
    isIntegratedPartner,
    ...rest,
  };
};
